<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>员工信息：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="工号：" required>
              <el-input v-model="employee_no" placeholder="工号" @blur="getEmployee" :disabled="isEdit" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="姓名：">
              <el-input v-model="employeeData.employee_name" placeholder="姓名" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="职位：">
              <el-input v-model="employeeData.position_id" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="员工类型：">
              <el-input v-model="employeeData.employee_type_str" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="入集团日期：">
              <el-date-picker v-model="employeeData.entry_corporation_date" type="date"
                              value-format="YYYY-MM-DD" style="width: 100%" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="入职日期：">
              <el-date-picker v-model="employeeData.entry_factory_date" type="date"
                              value-format="YYYY-MM-DD" style="width: 100%" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="部门：">
              <el-input v-model="employeeData.department_name" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <h4>离职办理：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px" :disabled="isShow" >
        <el-row>
          <el-col :span="11">
            <el-form-item label="离职日期：" required>
              <el-date-picker v-model="employeeData.resign_date" type="date" placeholder="选择日期"
                              value-format="YYYY-MM-DD" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="离职方式：" required>
              <el-select v-model="employeeData.resign_type" placeholder="请选择" >
                <el-option v-for="item in reasonList" :key="item.id" :label="item.leave_reason_name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注：">
              <el-input type="textarea" v-model="employeeData.remark" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="企业微信申请：" required v-if="!isEdit">
              <el-switch v-model="employeeData.is_check_approval"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="是否加入黑名单：" v-if="!isEdit">
              <el-switch v-model="employeeData.is_join_black"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="加黑原因：" v-if="employeeData.is_join_black">
              <el-input type="textarea" v-model="employeeData.black_remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <h4>附件：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px" :disabled="isShow">
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件：">
              <kf-file-upload v-model="employeeData.file_id" :init-file="fileList"
                              @fileChange="fileChange"
                              :limit="10" :showTotalCnt="true" ></kf-file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件照片：">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="">
              <FrameItem v-model="employeeData.attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj"  :disabled="isShow" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" :loading="loading" @click="saveEmployeeChange"  :disabled="isShow" >保存</el-button>
        </el-col>
      </el-row>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'

export default {
  name: "EmployeeResign",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList() {
      return this.$store.getters['core/getDictList']('bool');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      employee_no: '',
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        entry_date: '',
        is_probation: false,
        probation_end_date: '',
        labor_company_id:'',
        employee_type:'',
        is_check_approval: true
      },
      isEdit:false,
      isShow:false,
      photoType:'',
      dialogVisible: false,
      departmentList: [],
      reasonList: [],
      employeeList:[],
      loading: false,
      fileList:[],
      attach_photo_id_obj:[]
    }
  },
  methods: {
    async loadEmployeeResignRecord() {
      let params = {id: this.parentData.id}
      this.$http('employeeArchivesService.getResignById', params).then(data => {
        if (data) {
          this.isEdit = true;
          this.employee_no = data.employee_no;
          this.attach_photo_id_obj = data.attach_photo_id_obj;
          this.fileList = data.file_list;
          this.employeeData = data;
          if(this.componentParam === "employee_resign_detail"){
            this.isShow = true;
          }
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    //获取员工
    getEmployee(){
      let params = {employee_no: this.employee_no}
      this.$http('employeeArchivesService.getDataByEmpNo', params).then(data => {
        this.employeeData = data;
        this.employeeData.is_check_approval = true;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    //获取离职原因
    async getResignReason() {
      let params = {modelId: "hr_education_level"}
      this.reasonList = await this.$http('employeeArchivesService.getEmpLeaveReasonOptions',params);
      console.log(this.reasonList);
    },
    async openCameraMain(){
      this.dialogVisible = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisible = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.employeeData.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisible = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    saveEmployeeChange() {
      if (!this.employeeData) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.resign_date) {
        this.$message.error("请填写离职日期");
        return;
      }
      if (!this.employeeData.resign_type) {
        this.$message.error("请选择离职方式");
        return;
      }
      this.loading = true;
      this.$http('employeeArchivesService.saveEmpResignRecord', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    //拍照
    async openCamera() {
      this.dialogVisible = true;
      //设置分辨率
      const data = {
        "mode": "0",
        "camidx": "1",
        "width": "1280",
        "height": "720"
      }
      try{
        const image = document.getElementById('view2');
        axios.post("http://127.0.0.1:38088/device=setresolution", JSON.stringify(data)).then(response=>{
          console.log(response.data);
          if(response.data.code === "0"){
            image.src = '';
          }
          image.src = 'http://127.0.0.1:38088/video=stream&camidx=1?1';
        });
      }catch(error){
        this.$message.error("摄像头打开失败"+error.message);
      }
    },
    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.employeeData.file_id = ids;
    },
  },
  created() {
    this.getResignReason();
    this.loadEmployeeResignRecord();
  },
}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin: 10px 0;
}

</style>